var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6618 38.5412L43.5188 8.41975L40.5 5.5L17.0567 28.1742L6.33815 38.5412C5.22062 39.6234 5.22062 41.3766 6.33815 42.4588L27.7562 63.1742L40.5 75.5L63.9433 52.8258L64.3063 52.4747L74.6618 42.4588C75.7794 41.3766 75.7794 39.6234 74.6618 38.5412ZM40.5 50.8485L29.8005 40.5L40.5 30.1515L51.1995 40.5L40.5 50.8485Z",
    fill: "#2684FF",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5001 30.1515C33.4949 23.3753 33.4608 12.4 40.4237 5.58316L17.0091 28.2204L29.7529 40.5462L40.5001 30.1515Z",
    fill: "url(#paint0_linear_504_11743)",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2281 40.4722L40.5 50.8484C43.8812 54.1167 45.7809 58.5507 45.7809 63.1742C45.7809 67.7977 43.8812 72.2316 40.5 75.4999L63.9719 52.798L51.2281 40.4722Z",
    fill: "url(#paint1_linear_504_11743)",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_11743",
    x1: 38.5895,
    y1: 19.6829,
    x2: 20.7414,
    y2: 27.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_11743",
    x1: 42.5444,
    y1: 61.1969,
    x2: 60.3603,
    y2: 53.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraDark);
export default __webpack_public_path__ + "static/media/jira-dark.6d52bb68929c36d16b22f984fd52855f.svg";
export { ForwardRef as ReactComponent };